import { useState } from 'react';

type UseFavoriteProps = {
  isFavorite: boolean;
  isEnabled?: boolean;
};

export const useFavorite = ({ isFavorite, isEnabled = true }: UseFavoriteProps) => {
  const [isHovered, setIsHovered] = useState(false);

  const rowProps = isEnabled && {
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
  };

  const onFavoriteClick = () => {};

  return {
    isVisible: isFavorite || isHovered,
    isSelected: isFavorite,
    rowProps,
    onFavoriteClick,
  };
};
